import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
  path: '/login',
  component: () => import('@/views/login/index'),
  hidden: true
},
{
  path: '*',
  component: () => import('@/views/404'),
},
{
  path: '/404',
  component: () => import('@/views/404'),
  hidden: true
},
{
  path: '/',
  component: Layout,
  redirect: '/login',
},
{
  path: '/home',
  component: Layout,
  redirect: '/home/homePage',
  name: 'home',
  meta: {
    title: '首页',
    icon: 'home'
  },
  children: [{
    path: 'index',
    name: 'index',
    component: () => import('@/views/home/homePage/index'),
    meta: {
      title: '首页',
      icon: 'product-list'
    },
  },]
},
{
  path: '/auth',
  component: Layout,
  redirect: '/auth/users',
  name: '权限管理',
  meta: {
    title: '权限管理',
    icon: 'order'
  },
  children: [{
    path: 'users',
    name: '管理员列表',
    component: () => import(`@/views/authManager/authUsers`),
    meta: {
      title: '管理员列表',
      icon: 'product-list'
    },
  },
  {
    path: 'config',
    name: `权限分配`,
    component: () => import(`@/views/authManager/authConfig`),
    meta: {
      title: '权限分配',
      icon: 'product-list'
    },
  },
  {
    path: 'accessHospital',
      name: `医院分配`,
    component: () => import(`@/views/authManager/accessHospital`),
    meta: {
    title: '医院分配',
      icon: 'product-list'
  },
  }
  ]
},
{
  path: '/orderCenter',
  component: Layout,
  redirect: '/orderCenter/order',
  name: 'orderCenter',
  meta: {
    title: '订单管理中心',
    icon: 'order'
  },
  children: [{
    path: 'order',
    name: 'order',
    component: () => import('@/views/orderCenter/order/order'),
    meta: {
      title: '订单管理',
      icon: 'product-list'
    },
  },
  {
    path: 'orderAppointment',
    name: 'orderAppointment',
    component: () => import('@/views/orderCenter/order/orderAppointment'),
    meta: {
      title: '订单管理',
      icon: 'product-list'
    },
  },
  {
    path: 'orderDetail',
    name: 'orderDetail',
    component: () => import('@/views/orderCenter/order/orderDetail'),
    meta: {
      title: '订单详情'
    },
    hidden: true
  },
  {
    path: 'orderLog',
    name: 'orderLog',
    component: () => import('@/views/orderCenter/order/orderLog'),
    meta: {
      title: '订单记录'
    },
    hidden: true
  },
  {
    path: 'refundOrder',
    name: 'refundOrder',
    component: () => import('@/views/orderCenter/refundOrder/refundOrder'),
    meta: {
      title: '退款订单管理',
      icon: 'product-list'
    },
  },
  {
    path: 'contentService',
    name: 'contentService',
    component: () => import('@/views/orderCenter/service/contentService'),
    meta: {
      title: '评论审核',
      icon: 'product-list'
    },
  },
  {
    path: 'updatePrice',
    name: 'updatePrice',
    component: () => import('@/views/orderCenter/order/updatePrice'),
    meta: {
      title: '修改订单价格',
      icon: 'product-list'
    },
  },
  {
    path: 'orderContent',
    name: 'orderContent',
    component: () => import('@/views/orderCenter/service/orderContent'),
    meta: {
      title: '评论审核详情'
    },
    hidden: true
  },
  {
    path: 'assessLog',
    name: 'assessLog',
    component: () => import('@/views/orderCenter/service/assessLog'),
    meta: {
      title: '回复记录'
    },
    hidden: true
  },

    // {
    //   path: 'service',
    //   name: 'service',
    //   component: () => import('@/views/orderCenter/index'),
    //   meta: {
    //     title: '售后管理',
    //     icon: 'product-list'
    //   },
    //   redirect: '/orderCenter/service',
    //   children: [{
    //       path: 'service',
    //       name: 'service',
    //       component: () => import('@/views/orderCenter/service/contentService'),
    //       meta: {
    //         title: '评论审核',
    //         icon: 'product-list'
    //       },
    //     },
    //     {
    //       path: 'patientComplaints',
    //       name: 'patientComplaints',
    //       component: () => import('@/views/orderCenter/service/patientComplaints'),
    //       meta: {
    //         title: '建设中',
    //         icon: 'product-list'
    //       },
    //     }
    //   ]
    // }
  ]
},
{
  path: '/auditManagement',
  component: Layout,
  // redirect: '/auditManagement/patientCase',
  name: 'case',
  meta: {
    title: '运营及审核管理中心',
    icon: 'order'
  },
  children: [{
    path: '/auditManagement/patientCase',
    name: 'patientCase',
    component: () => import('@/views/auditManagement/patientCase'),
    meta: {
      title: '患友病例审核及管理',
      icon: 'product-list'
    },
  },
    {
      path: '/auditManagement/patientDetail',
      name: 'patientDetail',
      component: () => import('@/views/auditManagement/patientDetail'),
      meta: {
        title: '患友病例详情',
        icon: 'product-list'
      },
    },
    ]
},
// 供应链管理中心
{
  path: '/supplyChain',
  component: Layout,
  // redirect: '/supplyChain',
  name: 'pharmacyManagement',
  meta: {
    title: '供应链管理中心',
    icon: 'order'
  },
  children: [{
    path: '/supplyChain/pharmacyManagement',
    name: 'pharmacyManagement',
    component: () => import('@/views/supplyChain/pharmacyManagement/pharmacyManagement'),
    meta: {
      title: '合作药厂/药房管理',
      icon: 'product-list'
    },
  },
  {
          path: '/supplyChain/pharmacyDetail',
          name: 'pharmacyDetail',
          component: () => import('@/views/supplyChain/pharmacyManagement/pharmacyDetail'),
          meta: {
            title: '合作药厂/药房管理详情',
            icon: 'product-list'
          },
        },
  {
    path: '/supplyChain/drugManagement',
    name: 'drugManagement',
    component: () => import('@/views/supplyChain/drugManagement/drugManagement'),
    meta: {
      title: '供应链药品管理',
      icon: 'product-list'
    },
  },
  {
          path: '/supplyChain/drugDetail',
          name: 'drugDetail',
          component: () => import('@/views/supplyChain/drugManagement/drugDetail'),
          meta: {
            title: '新增供应链药品',
            icon: 'product-list'
          },
  },
  {
    path: '/supplyChain/updateDrugDetail',
      name: 'updateDrugDetail',
    component: () => import('@/views/supplyChain/drugManagement/updateDrugDetail'),
    meta: {
    title: '修改供应链药品',
      icon: 'product-list'
    },
  },
  {
    path: '/supplyChain/prescriptionManagement',
    name: 'prescriptionManagement',
    component: () => import('@/views/supplyChain/prescriptionManagement/prescriptionManagement'),
    meta: {
      title: '供应链处方管理',
      icon: 'product-list'
    },
  },
  {
    path: '/supplyChain/detail',
    name: 'detail',
    component: () => import('@/views/supplyChain/prescriptionManagement/prescriptionDetail'),
    meta: {
      title: '供应链处方详情',
      icon: 'product-list'
    },
  },

  {
    path: '/supplyChain/drugOrder',
    name: 'drugOrder',
    component: () => import('@/views/supplyChain/drugOrder/drugOrder'),
    meta: {
      title: '供应链药品订单',
      icon: 'product-list'
    },
  },
  {
          path: '/supplyChain/drugOrderDetail',
          name: 'drugOrderDetail',
          component: () => import('@/views/supplyChain/drugOrder/drugOrderDetail'),
          meta: {
            title: '供应链药品订单详情',
            icon: 'product-list'
          },
        },

  {
    path: '/supplyChain/pharmacistAccount',
    name: 'pharmacistAccount',
    component: () => import('@/views/supplyChain/pharmacistAccount/pharmacistAccount'),
    meta: {
      title: '供应链药师账号管理',
      icon: 'product-list'
    },
  },
  ]
},
{
  path: '/financeCenter',
  component: Layout,
  redirect: '/financeCenter/takeCashApplication',
  name: 'takeCashApplication',
  meta: {
    title: '财务管理中心',
    icon: 'order'
  },
  children: [{
    path: 'takeCashApplication',
    name: 'takeCashApplication',
    component: () => import('@/views/financeCenter/takeCashApplication/takeCashApplication'),
    meta: {
      title: '提现申请',
      icon: 'product-list'
    },
  },
  {
    path: 'financeLog',
    name: 'financeLog',
    component: () => import('@/views/financeCenter/financeLog/financeLog'),
    meta: {
      title: '资金监控日志',
      icon: 'product-list'
    },
  },

  {
    path: 'hospitalProportionControl',
    name: 'hospitalProportionControl',
    component: () => import('@/views/financeCenter/hospitalProportionControl/hospitalProportionControl'),
    meta: {
      title: '机构分成比例调控',
      icon: 'product-list'
    },
  },
  {
    path: 'doctorProportionControl',
    name: 'doctorProportionControl',
    component: () => import('@/views/financeCenter/doctorProportionControl/doctorProportionControl'),
    meta: {
      title: '医生/护士分成比例调控',
      icon: 'product-list'
    },
  },{
    path: 'performanceManagement',
    name: 'performanceManagement',
    component: () => import('@/views/financeCenter/performanceManagement/performanceManagement'),
    meta: {
      title: '绩效管理',
      icon: 'product-list'
    },
  },{
    path: 'profitDistribution',
    name: 'profitDistribution',
    component: () => import('@/views/financeCenter/profitDistribution/profitDistribution'),
    meta: {
      title: '分成比例设置',
      icon: 'product-list'
    },
  },{
    path: 'salesStatistics',
    name: 'salesStatistics',
    component: () => import('@/views/financeCenter/salesStatistics/salesStatistics'),
    meta: {
      title: '分成收费统计',
      icon: 'product-list'
    },
  },{
    path: 'prescriptionDetails',
    name: 'prescriptionDetails',
    component: () => import('@/views/financeCenter/salesStatistics/prescriptionDetails'),
    meta: {
      title: '处方详情',
      icon: 'product-list'
    },
  },
  ]
},
// 后期统一调整路由，科室数据统计和个人数据统计暂时先放在这里
{
  path: '/deptAndUserData',
  component: Layout,
  redirect: '/deptAndUserData/data',
  name: 'deptAndUserData',
  meta: {
    title: '科室/个人数据统计',
    icon: 'order'
  },
  children: [{
    path: 'deptData',
    name: 'dept',
    component: () => import('@/views/deptAndUserData/data/deptData'),
    meta: {
      title: '科室数据统计',
      icon: 'product-list'
    },
  },
  {
    path: 'userData',
    name: 'userData',
    component: () => import('@/views/deptAndUserData/data/userData'),
    meta: {
      title: '个人数据统计',
      icon: 'product-list'
    },
  }
  ]
},
{
  path: '',
  component: Layout,
  redirect: 'hospital',
  // name: 'home',
  meta: { title: '医院管理中心', icon: 'order' },
  children: [
    {
      path: 'questionnaireList',
      name: 'questionnaireList',
      component: () => import('@/views/questionnaireList/questionnaireList'),
      meta: { title: '调查表', icon: 'product-list' },
    },
    {
      path: 'healthAndPatient',
      name: 'healthAndPatient',
      component: () => import('@/views/healthAndPatient/healthAndPatient'),
      meta: { title: '健康管理者/患者', icon: 'product-list' },
    },
    {
      path: 'questionnaireList',
      name: 'questionnaireList',
      component: () => import('@/views/questionnaireList/questionnaireList'),
      meta: { title: '调查表', icon: 'product-list' },
    },
    {
      path: 'lookOverWrittenBy',
      name: 'lookOverWrittenBy',
      component: () => import('@/views/questionnaireList/lookOverWrittenBy'),
      meta: { title: '调查表', icon: 'product-list' },
    },
    {
      path: 'hospital',
      name: 'hospital',
      component: () => import('@/views/hospital/hospitalInfo'),
      meta: { title: '医院管理', icon: 'product-list' },
    },
    {
      path: 'department',
      name: 'department',
      component: () => import('@/views/hospital/department'),
      meta: {
        title: '科室管理'
      },
      hidden: true
    },
    {
      path: 'doctoraudit',
      name: 'doctoraudit',
      component: () => import('@/views/doctorAudit/doctorAudit'),
      meta: { title: '医生人员审核', icon: 'product-list' },
    },
    {
      path: 'doctorHelp',
        name: 'doctorHelp',
      component: () => import('@/views/doctorHelpManagement/doctorHelp'),
      meta: { title: '医助账号管理', icon: 'product-list' },
    },
    {
      path: 'defaulePrice',
      name: 'defaulePrice',
      component: () => import('@/views/price/defaulePrice'),
      meta: { title: '问诊默认价格管理', icon: 'product-list' },
    },
    {
      path: 'doctorPrice',
      name: 'doctorPrice',
      component: () => import('@/views/price/doctorPrice'),
      meta: { title: '问诊价格管理', icon: 'product-list' },
    },{
      path: 'remoteConsulPrice',
      name: 'remoteConsulPrice',
      component: () => import('@/views/price/remoteConsulPrice'),
      meta: { title: '院内会诊价格管理', icon: 'product-list' },
    },{
      path: 'remoteConsulHospitalPrice',
      name: 'remoteConsulHospitalPrice',
      component: () => import('@/views/price/remoteConsulHospitalPrice'),
      meta: { title: '院间会诊价格管理', icon: 'product-list' },
    },
    {
      path: 'doctorshow',
      name: 'doctorshow',
      component: () => import('@/views/doctorShow/doctorShow'),
      meta: { title: '医生数据展示', icon: 'product-list' },
    },
    {
      path: 'feedback',
      name: 'feedback',
      component: () => import('@/views/feedback/feedback'),
      meta: { title: '反馈管理', icon: 'product-list' },
    },
    {
      path: 'titleAudit',
      name: 'titleAudit',
      component: () => import('@/views/doctorAudit/titleAudit'),
      meta: { title: '医生职称审核', icon: 'product-list' },
    },
    {
      path: 'memberStratio',
      name: 'memberStratio',
      component: () => import('@/views/memberStratio/memberStratio'),
      meta: { title: '患者管理', icon: 'product-list' },
    },
    {
      path: 'pharmacyPublicOrderReceivingPool',
      name: 'pharmacyPublicOrderReceivingPool',
      component: () => import('@/views/publicOrderReceivingPool/pharmacyPublicOrderReceivingPool'),
      meta: { title: '药房公共接单池价格管理', icon: 'product-list' },
    },
  {
    path: 'doctorPharmacyPublicOrderReceivingPool',
    name: 'doctorPharmacyPublicOrderReceivingPool',
    component: () => import('@/views/doctorPharmacyPrice/doctorPharmacyPublicOrderReceivingPool'),
    meta: { title: '药房门诊医生接单价格管理', icon: 'product-list' },
  },
    {
      path: 'dimDay',
      name: 'dimDay',
      component: () => import('@/views/dimDay/dimDay'),
      meta: { title: '日历管理', icon: 'product-list' },
    },
    {
      path: 'questionnaire',
        name: 'questionnaire',
      component: () => import('@/views/questionnaireList/questionnaireList'),
      meta: { title: '调查表管理', icon: 'product-list' },
    },
    {
      path: 'questionnaireEdit',
        name: 'questionnaireEdit',
      component: () => import('@/views/createQuestionnaire/questionnaireEdit'),
      meta: {
      title: '编辑调查表',
        icon: 'product-list'},
    },{
      path: 'questionnaireDetail',
        name: 'questionnaireDetail',
      component: () => import('@/views/createQuestionnaire/questionnaireDetail'),
      meta: {
      title: '调查表详情',
        icon: 'product-list'},
    },{
      path: 'questionnaireResults',
       name: 'questionnaireResults',
      component: () => import('@/views/createQuestionnaire/questionnaireResults'),
      meta: {
      title: '用户填写详情',
        icon: 'product-list'},
    },
    {
      path: 'questionnaireOption',
        name: 'questionnaireOption',
      component: () => import('@/views/questionnaire/questionnaireOption'),
      meta: {
      title: '调查表题目',
        icon: 'product-list'},
    },
    {
      path: 'questionnaireUser',
        name: 'questionnaireUser',
      component: () => import('@/views/questionnaire/questionnaireUser'),
      meta: {
      title: '调查表相关用户',
        icon: 'product-list'},
    },
    // {
    //   path: 'questionnaireResult',
    //     name: 'questionnaireResult',
    //   component: () => import('@/views/questionnaire/questionnaireResult'),
    //   meta: {
    //   title: '用户填写结果',
    //     icon: 'product-list'},
    // },


  {
      path: 'drug',
      name: 'drug',
      component: () => import('@/views/drug/drug'),
      meta: { title: '药品管理', icon: 'product-list' },
    },
    {
      path: 'drugDetail',
      name: 'drugDetail',
      component: () => import('@/views/drug/drugDetail'),
      meta: { title: '药品详情', icon: 'product-list' },
    },
    {
      path: 'drugsProcessingMethods',
      name: 'drugsProcessingMethods',
      component: () => import('@/views/drugsProcessingMethods/drugsProcessingMethods'),
      meta: { title: '药品加工方式管理', icon: 'product-list' },
    },
    {
      path: 'drugClassification',
      name: 'drugClassification',
      component: () => import('@/views/drugClassification/drugClassification'),
      meta: { title: '药品分类管理', icon: 'product-list' },
    },
    {
      path: 'drugClassificationDetail',
      name: 'drugClassificationDetail',
      component: () => import('@/views/drugClassification/drugClassificationDetail'),
      meta: { title: '二级药品分类管理', icon: 'product-list' },
    },
    {
      path: 'tempalteDrugs',
      name: 'tempalteDrugs',
      component: () => import('@/views/tempalteDrugs/tempalteDrugs'),
      meta: { title: '药品模板管理', icon: 'product-list' },
    },
    {
      path: 'tempalteDrugsDetail',
      name: 'tempalteDrugsDetail',
      component: () => import('@/views/tempalteDrugs/tempalteDrugsDetail'),
      meta: { title: '药品模板详情', icon: 'product-list' },
    },
    {
      path: 'followUpPlan',
        name: 'followUpPlan',
      component: () => import('@/views/follow/followUpPlan'),
      meta: { title: '随访计划', icon: 'product-list' },

    },
    {
      path: 'followUpPlanDetail',
        name: 'followUpPlanDetail',
      component: () => import('@/views/follow/followUpPlanDetail'),
      meta: { title: '随访计划详情', icon: 'product-list' }
    },
  {
    path: 'followUpTask',
      name: 'followUpTask',
    component: () => import('@/views/follow/followUpTask'),
    meta: { title: '随访计划任务', icon: 'product-list' }
  },
  {
    path: 'followUpTaskContent',
      name: 'followUpTaskContent',
    component: () => import('@/views/follow/followUpTaskContent'),
    meta: { title: '随访计划任务内容', icon: 'product-list' }
  },
  {
    path: 'followMyMemberCard',
      name: 'followMyMemberCard',
    component: () => import('@/views/follow/followMyMemberCard'),
    meta: { title: '随访计划相关患者', icon: 'product-list' }
  },
  {
    path: 'followMyMemberDetail',
      name: 'followMyMemberDetail',
    component: () => import('@/views/follow/followMyMemberDetail'),
    meta: { title: '随访计划相关患者详情', icon: 'product-list' }
  },
  {
    path: 'doctorTeam',
      name: 'doctorTeam',
    component: () => import('@/views/doctorTeam/doctorTeam'),
    meta: { title: '医生团队', icon: 'product-list' },
  },
  {
    path: 'doctorTeamDetail',
      name: 'doctorTeamDetail',
    component: () => import('@/views/doctorTeam/doctorTeamDetail'),
    meta: { title: '医生团队详情', icon: 'product-list' },
  },
  {
    path: 'doctorTeamMember',
      name: 'doctorTeamMember',
    component: () => import('@/views/doctorTeam/doctorTeamMember'),
    meta: { title: '成员列表', icon: 'product-list' },
  },
  {
    path: 'therapeuticManagement',
    name: 'therapeuticManagement',
    component: () => import('@/views/therapeuticManagement/therapeuticManagement'),
    meta:{ title: '治疗方管理',keepAlive: true}
  },
  {
    path: 'therapeuticMaterialManagement',
    name: 'therapeuticMaterialManagement',
    component: () => import('@/views/therapeuticManagement/therapeuticMaterialManagement'),
    meta:{ title: '耗材管理',keepAlive: true}
  },
  {
    path: 'therapeuticSiteManagement',
    name: 'therapeuticSiteManagement',
    component: () => import('@/views/therapeuticManagement/therapeuticSiteManagement'),
    meta:{ title: '治疗场地管理',keepAlive: true}
  },
]
},

{
  path: '/dataCenter',
  component: Layout,
  redirect: '/dataCenter/data',
  name: 'dataCenter',
  meta: {
    title: '首页数据中心',
    icon: 'order'
  },
  children: [{
    path: 'index',
    name: 'index',
    component: () => import('@/views/dataCenter/data/index'),
    meta: {
      title: '首页数据中心',
      icon: 'product-list'
    },
  },]
},
{
  path: '/demo',
  component: Layout,
  redirect: '/demo/demoManager',
  name: 'demo',
  meta: {
    title: 'DEMO',
    icon: 'order'
  },
  children: [{
    path: 'demoPage',
    name: 'demoPage',
    component: () => import('@/views/demo/demoManager/demoPage'),
    meta: {
      title: '列表页面demo',
      icon: 'product-list'
    },
  },
  {
    path: 'otherPage',
    name: 'otherPage',
    component: () => import('@/views/demo/demoManager/otherPage'),
    meta: {
      title: '列表页面。。。',
      icon: 'product-list'
    },
  },
  {
    path: 'demoDetail',
    name: 'demoDetail',
    component: () => import('@/views/demo/demoManager/demoDetail'),
    meta: {
      title: '详情页面demo'
    },
    hidden: true
  },
  ]
},
{
  path: '/banner',
  component: Layout,
  redirect: '/banner',
  name: 'banner',
  meta: { title: 'BANNER', icon: 'order' },
  children: [
    {
      path: 'bannerHome',
      name: 'bannerHome',
      component: () => import('@/views/banner/bannerHome'),
      meta: { title: 'Banner列表', icon: 'product-list' },
    }
  ]
},
{
  path: '/announcement',
  component: Layout,
  redirect: '/announcement',
  name: 'announcement',
  meta: { title: 'ANNOUNCEMENT', icon: 'order' },
  children: [
    {
      path: 'announcements',
      name: 'announcements',
      component: () => import('@/views/announcement/announcements'),
      meta: { title: '公告列表', icon: 'product-list' },
    }
  ]
},
{
  path: '/homepage',
  component: Layout,
  redirect: '/homepage',
  name: 'homepage',
  meta: { title: 'HOMEPAGE', icon: 'order' },
  children: [
    {
      path: 'homepages',
      name: 'homepages',
      component: () => import('@/views/homepage/homepages'),
      meta: { title: '首页推荐', icon: 'product-list' },
    },
    {
      path: 'sentiments',
      name: 'sentiments',
      component: () => import('@/views/homepage/sentiments'),
      meta: { title: '人气医生', icon: 'product-list' },
    },
  ]
},
{
  path: '/doctormanagement',
  component: Layout,
  redirect: '/doctormanagement',
  name: 'announcement',
  meta: { title: 'DOCTORMANAGEMENT', icon: 'order' },
  children: [
    {
      path: 'doctormanagements',
      name: 'doctormanagements',
      component: () => import('@/views/doctormanagement/doctormanagements'),
      meta: { title: '医生管理', icon: 'product-list' },
    },
    {
      path: 'addDoctor',
      name: 'addDoctor',
      component: () => import('@/views/doctormanagement/addDoctor'),
      meta: { title: '新增医生' },
    }
  ]
},
{
  path: '/nursemanagement',
  component: Layout,
  redirect: '/nursemanagement',
  name: 'anursemanagement',
  meta: { title: 'NURSEMANAGEMENT', icon: 'order' },
  children: [
    {
      path: 'nursemanagements',
      name: 'nursemanagements',
      component: () => import('@/views/nursemanagement/nursemanagements'),
      meta: { title: '护士管理', icon: 'product-list' },
    }
  ]
},
{
  path: '/forgotpassword',
  component: Layout,
  redirect: '/forgotpassword',
  name: 'forgotpassword',
  meta: { title: 'FORGOTPASSWORD', icon: 'order' },
  children: [
    {
      path: 'forgotpasswords',
      name: 'forgotpasswords',
      component: () => import('@/views/forgotpassword/forgotpasswords'),
      meta: { title: '忘记密码', icon: 'product-list' },
    }
  ]
},
{
  path: '/pharmacist',
  component: Layout,
  redirect: '/pharmacist',
  name: 'pharmacist',
  meta: { title: 'PHARMACIST', icon: 'order' },
  children: [
    {
      path: 'pharmacists',
      name: 'pharmacists',
      component: () => import('@/views/pharmacist/pharmacists'),
      meta: { title: '药师列表', icon: 'product-list' },
    }
  ]
},
  {
    path: '/trainingManagement',
    component: Layout,
    redirect: '/trainingManagement/liveGift',
    name: 'trainingManagement',
    meta: {
      title: '培训管理中心',
      icon: 'trainingManagement'
    },
    children: [{
      path: 'liveGift',
      name: 'liveGift',
      component: () => import('@/views/trainingManagement/liveGift/liveGift'),
      meta: {
        title: '礼物管理',
        icon: 'product-list'
      },
    },
    {
      path: 'trainingClass', name: 'trainingClass',
      component: () => import('@/views/trainingManagement/trainingClass'),
      meta: { title: '培训班管理', icon: 'product-list' },
      // children: [
      //   {
      //     path: 'trainingClassDetail',
      //     name: 'trainingClassDetail',
      //     component: () => import('@/views/trainingManagement/trainingClassDetail'),
      //     meta: { title: '培训班详情', icon: 'product-list' },
      //   }
      // ]
    },
    {
      path: 'trainingClassDetail', name: 'trainingClassDetail',
      component: () => import('@/views/trainingManagement/trainingClassDetail'),
      meta: { title: '培训班详情', icon: 'product-list' },
    },
    {
      path: 'trainingClassLog', name: 'trainingClassLog',
      component: () => import('@/views/trainingManagement/trainingClassLog'),
      meta: { title: '培训动态记录', icon: 'product-list' },
    },
    {
      path: 'trainingClassCourseList',
        name: 'trainingClassCourseList',
      component: () => import('@/views/trainingManagement/trainingClassCourseList'),
      meta: { title: '课程列表', icon: 'product-list' },
    },
    {
      path: 'trainingClassCourse',
        name: 'trainingClassCourse',
      component: () => import('@/views/trainingManagement/trainingClassCourse'),
      meta: { title: '课程管理', icon: 'product-list' },
    },
    {
      path: 'trainingClassCourseDetail', name: 'trainingClassCourseDetail',
      component: () => import('@/views/trainingManagement/trainingClassCourseDetail'),
      meta: { title: '课程详情', icon: 'product-list' },
    },
    {
      path: 'trainingClassCourseLog', name: 'trainingClassCourseLog',
      component: () => import('@/views/trainingManagement/trainingClassCourseLog'),
      meta: { title: '课程记录', icon: 'product-list' },
    },
    {
      path: 'applyLeave', name: 'applyLeave',
      component: () => import('@/views/trainingManagement/applyLeave'),
      meta: { title: '请假管理', icon: 'product-list' },
    },
    {
      path: 'applyLeaveDetail', name: 'applyLeaveDetail',
      component: () => import('@/views/trainingManagement/applyLeaveDetail'),
      meta: { title: '请假详情', icon: 'product-list' },
    },
    {
      path: 'leaveType', name: 'leaveType',
      component: () => import('@/views/trainingManagement/leaveType'),
      meta: { title: '请假类型', icon: 'product-list' },
    },
    ]
  },



{
  path: '/trainingManagement',
    component: Layout,
  redirect: '/trainingManagement/centerAccount',
  name: 'trainingManagement',
  meta: {
  title: '培训管理中心',
    icon: 'trainingManagement'
},
  children: [
    {
      path: 'centerAccount',
      name: 'centerAccount',
      component: () => import('@/views/trainingManagement/centerAccount/centerAccount'),
    meta: {title: '学习中心账户管理', icon: 'product-list'},
},
  {
    path: 'centerAccountDetail',
      name: 'centerAccountDetail',
    component: () => import('@/views/trainingManagement/centerAccount/centerAccountDetail'),
    meta: {title: '学习中心账户详情', icon: 'product-list'},
  }
]},
{
  path: '/queueNumber',
    component: Layout,
  redirect: '/queueNumber/equipment',
  name: 'equipment',
  meta: {
  title: '排队叫号管理中心',
    icon: 'product-list'
},
  children: [

    {
      path: 'equipment',
      name: 'equipment',
      component: () => import('@/views/queueNumber/equipment/equipment'),
    meta: { title: '设备管理', icon: 'product-list' },

    },
    {
      path: 'equipmentDetail',
        name: 'equipmentDetail',
      component: () => import('@/views/queueNumber/equipment/equipmentDetail'),
      meta: { title: '设备详情', icon: 'product-list' },

    },
    {
      path: 'clinicRoom',
        name: 'clinicRoom',
      component: () => import('@/views/queueNumber/clinicRoom/clinicRoom'),
      meta: { title: '诊室管理', icon: 'product-list' },

    },
    {
      path: 'clinicRoomDetail',
        name: 'clinicRoomDetail',
      component: () => import('@/views/queueNumber/clinicRoom/clinicRoomDetail'),
      meta: { title: '诊室详情', icon: 'product-list' },

    }
]
},
  {
    path: '/articletype',
    component: Layout,
    redirect: '/articletype',
    name: 'articletype',
    meta: { title: 'ARTICLETYPE', icon: 'order' },
    children: [
      {
        path: 'articletypes',
        name: 'articletypes',
        component: () => import('@/views/articletype/articletypes'),
        meta: { title: '文章列表', icon: 'product-list' },
      }
    ]
  },
  {
    path: '/article',
    component: Layout,
    redirect: '/article',
    name: 'article',
    meta: { title: 'ARTICLE', icon: 'order' },
    children: [
      {
        path: 'article',
        name: 'article',
        component: () => import('@/views/article/article'),
        meta: { title: '文章管理', icon: 'product-list' },
      }
    ]
  },
{
  path: '/flowSurveyModule',
  component: Layout,
  redirect: '/flowSurvey',
  name: 'flowSurveyModule',
  meta: { title: '流调相关' } ,
  children:[
    {
      path: 'queryFlowSurvey',
      name: 'queryFlowSurvey',
      component: () => import('@/views/flowSurveyModule/queryFlowSurvey'),
      meta:{ title: '流调记录查询',keepAlive: true}
    },{
      path: 'flowSurveyDetail',
      name: 'flowSurveyDetail',
      component: () => import('@/views/flowSurveyModule/flowSurveyDetail'),
      meta:{ title: '流调记录详情'}
    }
  ]
},
{
  path: '/flowAdjustable',
  component: Layout,
  redirect: '/flowAdjustable',
  name: 'flowAdjustable',
  meta: { title: '流调管理' },
  children:[
    {
      path: 'subject',
      name: 'subject',
      component: () => import('@/views/flowAdjustable/subject'),
      meta:{ title: '流调题目管理',keepAlive: true}
    },
    {
      path: 'subjectDetails',
      name: 'subjectDetails',
      component: () => import('@/views/flowAdjustable/subjectDetails'),
      meta:{ title: '流调题目管理详情',keepAlive: true}
    },
    {
      path: 'addSubject',
      name: 'addSubject',
      component: () => import('@/views/flowAdjustable/addSubject'),
      meta:{ title: '添加流调题目',keepAlive: true}
    },
  ]
},
{
  path: '/remoteScheduleManager',
  component: Layout,
  meta: { title: '专家门诊管理' },
  children:[
    {
      path: 'registerTypeManagement',
      name: 'registerTypeManagement',
      component: () => import('@/views/remoteScheduleManager/registerTypeManagement'),
      meta:{ title: '挂号类别管理', keepAlive: true}
    },
    {
      path: 'outpatientNumberManagement',
      name: 'outpatientNumberManagement',
      component: () => import('@/views/remoteScheduleManager/outpatientNumberManagement'),
      meta:{ title: '门诊号别设置', keepAlive: true}
    },
    { 
      path: 'remoteScheduleOperate',
      name: 'remoteScheduleOperate',
      component: () => import('@/views/remoteScheduleManager/remoteScheduleOperate/remoteScheduleOperate.vue'),
      meta:{ title: '门诊排期', keepAlive: true}
    }
  ]
},
{
  path: '/onLineScheduleManager',
  component: Layout,
  meta: { title: '互联网医院线上排期' },
  children:[
    { 
      path: 'onLineScheduleOperator',
      name: 'onLineScheduleOperator',
      component: () => import('@/views/onLineScheduleManager/onLineScheduleOperator/onLineScheduleOperator.vue'),
      meta:{ title: '线上排期', keepAlive: true}
    }
  ]
},
{
  path: '/copyOfCase',
  component: Layout,
  meta: { title: '病例复印' },
  children:[
    {
      path: 'copyOfCaseList',
      name: 'copyOfCaseList',
      component: () => import('@/views/copyOfCase/copyOfCaseList.vue'),
      meta:{ title: '全部申请', keepAlive: true}
    }
  ]
},
{
  path: '*',
  redirect: '/404',
  hidden: true
}
]
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap,

})



// WEBPACK FOOTER //
// ./src/router/index.js